import { Button, SelectInput, TextInput, useForm } from '@rocketmakers/armstrong';
import * as React from 'react';
import { IUpdateBee, Project } from '../../../../shared/api-clients/_api';
import { useRoutePaths } from '../../../../shared/context/paths';
import { generateSelectOptions } from '../../../../shared/helpers/enumHelpers';
import { useValidatedForm } from '../../../../shared/hooks/formValidationHook';
import { useBee } from '../../../../shared/hooks/useBee';
import { InputValidator } from '../../../../shared/hooks/ValidationTypes';
import { requiredTextInputValidator, Validator } from '../../../../shared/hooks/Validators';
import { BackButton } from '../../components/buttons/back-button';
import { routePaths } from '../../routes';
import './plot.scss';

interface IPlotForm extends Pick<IUpdateBee, 'project' | 'plot'> {
  project: Project;
  plot: string;
}

export const validators: InputValidator<IPlotForm>[] = [
  {
    key: 'plot',
    validators: [requiredTextInputValidator],
  },
  {
    key: 'project',
    validators: [
      requiredTextInputValidator,
      { message: '', validate: Validator.requiredStringKey(...Object.values(Project)) },
    ],
  },
];

export const PlotView: React.FunctionComponent = () => {
  const { beeInfo, updateBee } = useBee();
  const { push } = useRoutePaths();
  const formState = React.useMemo(() => ({ plot: beeInfo?.bee?.plot, project: beeInfo?.bee?.project }), [beeInfo]);
  const { DataForm, dataBinder, bind } = useForm(formState);
  const { formIsValid, validationErrors, setTouched } = useValidatedForm<IPlotForm>(validators, dataBinder);

  const handleContinue = async () => {
    const plotAndProject = dataBinder.toJson() as IPlotForm;
    await updateBee({ deviceId: beeInfo.bee.deviceId, ...plotAndProject });
    push(routePaths.meterType.root);
  };

  return (
    <DataForm validationResults={validationErrors} validationMode="both">
      <BackButton />
      <h1>Plot & Project</h1>
      <div>
        <SelectInput
          {...bind.select('project')}
          data-qa="project"
          label="Select a project from the list below:"
          options={generateSelectOptions(Project)}
          onBlur={setTouched}
        />
        <TextInput {...bind.text('plot')} data-qa="plot" label="Enter the plot number" onBlur={setTouched} />
      </div>

      <div className="row">
        <span className="spacer" />
        <Button
          data-qa="continue-button"
          className="continue-button btn-full btn-large"
          disabled={!formIsValid}
          onClick={handleContinue}
        >
          Continue
        </Button>
      </div>
    </DataForm>
  );
};
